export default __webpack_public_path__ + "img/m3.asset.dec596f4.png";